<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="false"
      :tableData="tableData"
      :tableTitle="'Job'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    />
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import API from '../../../../api/endpoints'
  export default {
    name: 'JobSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Job Name', prop: item => item.jobName },
          { header: 'Origin', prop: item => item.fromLocation && this.displayLocation(item.fromLocation) },
          { header: 'Destination', prop: item => item.toLocation && this.displayLocation(item.toLocation) },
          { header: 'Job Type', prop: item => item.jobType && item.jobType.name },
          { header: 'Ref', prop: 'jobRef' },
          { header: 'External Ref', prop: 'externalRef' }
        ],
        loading: false,
        tableData: [],
        entityName: 'job',
        editEntityScreen: 'Admin - Edit/View Job',
        shouldSearchForExactMatch: true,
        orderBy: 'id DESCENDING'
      }
    },
    computed: {
      reqBody () {
        return this.trimmedSearch
      },
      trimmedSearch () {
        const search = { primaryJob: 1 }
        if (this.isFullSearch) {
          const full = JSON.parse(this.query['search'])
          if (full.fromLocation && full.fromLocation.id) { search.fromLocation = full.fromLocation.id }
          if (full.toLocation && full.toLocation.id) { search.toLocation = full.toLocation.id }
          if (full.jobType) { search.jobType = full.jobType }
          if (full.jobName) { search.jobName = full.jobName }
          if (full.jobRef) { search.jobRef = full.jobRef }
        }
        return search
      }
    },
    methods: {
      displayLocation (location) {
        let str = ''
        if (location.name) {
          str += location.name
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      quickSearch (opts) {
        return this.fullSearch(opts)
      },
      fullSearch (opts) {
        return this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH(this.entityName), {
          params: this.clearEmpties(this.reqBody),
          headers: {
            'X-Lazy-Fetch': this.lazy || '1',
            'X-Order-By': this.orderBy,
            ...opts
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// JobSearchResults.vue?39e88915